__turbopack_context__.v({
  "form": "RegisterModal-module-scss-module__1WI7qG__form",
  "link": "RegisterModal-module-scss-module__1WI7qG__link",
  "referral": "RegisterModal-module-scss-module__1WI7qG__referral",
  "resend": "RegisterModal-module-scss-module__1WI7qG__resend",
  "success-content": "RegisterModal-module-scss-module__1WI7qG__success-content",
});
